var map = {
	"./CourtCases.png": 725,
	"./FinancialMortgage.png": 32554,
	"./HealthHistory.png": 99079,
	"./LegalDocuments.png": 82906,
	"./digitalUse.png": 29000,
	"./gavelUse.png": 21955,
	"./governmentUse.png": 36119,
	"./hatUse.png": 95593,
	"./keyUse.png": 6615,
	"./legalUse.png": 11105,
	"./mailUse.png": 9407,
	"./medicalUse.png": 20175,
	"./penUse.png": 22203,
	"./torchUse.png": 56682
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60018;